export default __webpack_public_path__ + "static/media/alcohol-and-drug-activity.14638555.svg";